<template>
  <FormAddModal
    v-model="show"
    :title="item ? $t('systemMessage.editTitle') : $t('systemMessage.createTitle')"
    :valid.sync="valid"
    :action="$t('Save')"
    @submit="submit"
    @input="reset"
  >
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="systemMessageData.title" :rules="[$rules.required]" :label="$t('systemMessage.title')" />
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="systemMessageData.type_id"
          :items="types"
          item-text="name"
          item-value="id"
          :rules="[$rules.required]"
          :label="$t('systemMessage.type')"
          @input="setType"
        />
      </v-col>
      <v-col cols="12" md="6">
        <ftw-date-time-field v-model="systemMessageData.begin" :label="$t('systemMessage.begin')" />
      </v-col>
      <v-col cols="12" md="6">
        <ftw-date-time-field
          v-model="systemMessageData.end"
          :before="systemMessageData.begin"
          :label="$t('systemMessage.end')"
          clearable
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="systemMessageData.text" :rules="[$rules.required]" :label="$t('systemMessage.text')" />
      </v-col>
      <v-col cols="12" md="6">
        <ftw-color-picker
          v-model="systemMessageData.text_color"
          default="#FFFFFF"
          :label="$t('systemMessage.textColor')"
        />
      </v-col>
      <v-col cols="12" md="6">
        <ftw-color-picker
          v-model="systemMessageData.background_color"
          default="#0000FF"
          :label="$t('systemMessage.backgroundColor')"
        />
      </v-col>
      <v-col cols="12">
        <span>{{ $t('systemMessage.preview') }}</span>
        <ftw-system-bar-alert :key="systemMessageData?.type?.icon" :item="systemMessageData" item-icon="type.icon" />
      </v-col>
    </v-row>
    <template #activator="props">
      <slot v-bind="props" name="activator" />
    </template>
  </FormAddModal>
</template>

<script>
import { join } from 'path'
import { cloneDeep } from 'lodash'
import { api } from '@/api'
import { createLink } from '@/api/helpers'

export default {
  name: 'SystemMessageModal',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    types: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      valid: null,
      show: false,
      systemMessageData: this.item ? cloneDeep(this.item) : {},
    }
  },
  methods: {
    reset() {
      this.systemMessageData = this.item ? cloneDeep(this.item) : {}
    },
    async create() {
      await api.post(createLink('system_message'), this.systemMessageData)
      this.reset()
    },
    async update() {
      await api.patch(createLink(join('system_message', this.item.id.toString())), this.systemMessageData)
    },
    async submit() {
      try {
        if (this.item) {
          await this.update()
        } else {
          await this.create()
        }
      } catch (e) {
        if (e.response?.data?.text) {
          this.notifyError(e.response.data.text)
        } else {
          this.notifyError(this.$t('systemMessage.error'))
        }
        return
      }
      this.$emit('success', this.systemMessageData)
      this.notifySuccess(this.$t('systemMessage.success'))
      this.show = false
    },
    open() {
      this.show = true
    },
    setType(id) {
      this.systemMessageData.type = this.types.find((type) => type.id === id)
    },
  },
}
</script>
